import React, { useState } from "react";
import "./Image.css";
import { ImageOff } from "lucide-react";

const Image = ({ src, alt, ...props }) => {
  const [hasError, setHasError] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const handleError = () => setHasError(true);
  const handleLoad = () => setLoaded(true);

  if (hasError || !src) {
    return (
      <div
        className={`Image--Fallback ${props.className || ""}`}
        style={props.style}
        aria-label={alt || "Изображение недоступно"}
      >
        <ImageOff size={22} />
        <span>Нет фото</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      onError={handleError}
      onLoad={handleLoad}
      loading="lazy"
      {...props}
      className={`${props.className || ""} ${loaded ? "is-loaded" : "is-loading"}`}
    />
  );
};

export default Image;
